import PurchaseInfo from './PurchaseInfo';

export default PurchaseInfo;
